import React from 'react';

import styles from './Table.module.scss';

interface bodyInterface {
  [index: number]: string[];
}

export interface TableProps {
  head?: string[];
  body: bodyInterface[];
  classNamePrefix?: string;
  renderCustomCell?: (td: string, index: number, items: any) => void;
}

const renderCell = (td: string, o: number, classNamePrefix: string) => {
  return (
    <td key={o}>
      <div className={`${classNamePrefix}__cell-height`}>{td}</div>
    </td>
  );
};

const Table: React.FC<TableProps> = ({
  head,
  body,
  classNamePrefix = 'td',
  renderCustomCell,
}) => {
  return (
    <table data-testid="table" className={styles.OneUITable}>
      <thead>
        <tr>
          {head?.map((item: string, i: number) => (
            <th key={i}>{item}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {body?.map((items: any, i: number) => (
          <tr key={i}>
            {items.map((td: string, index: number) =>
              renderCustomCell
                ? renderCustomCell(td, index, items)
                : renderCell(td, index, classNamePrefix)
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
